const SEC_IN_HR = 3600;
const SECOND_FORMAT = 'HH:mm:ss';
const MINUTE_FORMAT = 'HH:mm';
const DAY_FORMAT = 'MM/DD';
const DAY_FORMAT_SUPPRESS = 'M/D';
const DATE_FORMAT = 'YYYY/MM/DD';
const INPUT_DATE_FORMAT = 'YYYY-MM-DD';
const DATETIME_FORMAT = 'YYYY/MM/DD HH:mm:ss';
const MONTH_FORMAT = 'YYYY/MM';
const YEAR_FORMAT = 'YYYY';
const TIMEOUT = 10000;
const DAYTIME_FORMAT = 'YYYY/MM/DD HH:mm';

const SNACKBAR_OPTIONS = {
    position: {
      vertical: 'top',
      horizontal: 'center',
    },
    style: {
      backgroundColor: 'red',
      border: '1px solid white',
      color: 'white',
      fontFamily: 'Meiryo',
      fontSize: '16px',
      textAlign: 'center',
    },
    closeStyle: {
      color: 'lightcoral',
      fontSize: '16px',
    },
}

const GREEN_SNACKBAR_OPTIONS = {
  position: {
    vertical: 'top',
    horizontal: 'center',
  },
  style: {
    backgroundColor: '#20B334',
    border: '1px solid white',
    color: 'white',
    fontFamily: 'Meiryo',
    fontSize: '16px',
    textAlign: 'center',
  },
  closeStyle: {
    color: '#6FD37D',
    fontSize: '16px',
  },
}

const CLONE_USER = {
  clone: "_ceopencompass",
  clonePw: "ceCloneUser123456789"
};

const Ultimate_URL = {
  advdev: "https://dnb8xeb4rovrv.cloudfront.net/",
  dev: "https://dnb8xeb4rovrv.cloudfront.net/",
  stg: "https://d1viyepfz389a3.cloudfront.net/",
  hotfix: "https://d1viyepfz389a3.cloudfront.net/",
  sam: "https://ditaja68n2zpp.cloudfront.net",
  prod: "https://dashboard-u.konicaminolta.com",
};

const LABELSN_PREFIX = ['AD7E', 'AAK7'];

const TUTORIALS_LINK = {
  //dev・advdev　⇒　チュートリアルのdev  stg・hotfix　⇒　チュートリアルのstg
  advdev:"https://d24yy7bo0pa04y.cloudfront.net/",
  dev: "https://d24yy7bo0pa04y.cloudfront.net/",
  stg: "https://d1rxa20peeylxo.cloudfront.net/",
  hotfix:"https://d1rxa20peeylxo.cloudfront.net/",
  prod: "https://dashboard-jm-tutorial.konicaminolta.com",
  sam: "https://d3pmka39wcmbc6.cloudfront.net"
}

const FLUX_WEBHOOK_URL = {
  advdev: "https://vl4ehfqxe1.execute-api.ap-northeast-1.amazonaws.com/jmadvdev/dandori/schedule/flux/auth",
  dev: "https://lw21ew08oe.execute-api.ap-northeast-1.amazonaws.com/jmdev/dandori/schedule/flux/auth",
  stg: "https://hecjf1z1bc.execute-api.ap-northeast-1.amazonaws.com/jmstg/dandori/schedule/flux/auth",
  sam: "https://l1d48z7x7c.execute-api.ap-northeast-1.amazonaws.com/jmsam/dandori/schedule/flux/auth",
  hotfix:"https://rs9adzn930.execute-api.ap-northeast-1.amazonaws.com/jmhotfix/dandori/schedule/flux/auth",
  prod : "https://isim70w8x4.execute-api.ap-northeast-1.amazonaws.com/jmprod/dandori/schedule/flux/auth"
};
const AES_KEY = "Jf2$laGt3*!RpQbY"

module.exports = {
    SEC_IN_HR,
    SNACKBAR_OPTIONS,
    GREEN_SNACKBAR_OPTIONS,
    SECOND_FORMAT,
    MINUTE_FORMAT,
    DAY_FORMAT,
    DAY_FORMAT_SUPPRESS,
    DATE_FORMAT,
    DATETIME_FORMAT,
    MONTH_FORMAT,
    INPUT_DATE_FORMAT,
    TIMEOUT,
    YEAR_FORMAT,
    CLONE_USER,
    Ultimate_URL,
    DAYTIME_FORMAT,
    LABELSN_PREFIX,
    TUTORIALS_LINK,
    FLUX_WEBHOOK_URL,
    AES_KEY
};